const runtimeToken = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`

// Module state is isolated per browser document, unlike sessionStorage which
// browsers may clone into a newly opened tab.
export const tableClientToken = () => runtimeToken
